export default __webpack_public_path__ + "b53e31b372af0626e93cb4cf50d74c23.svg";